import styles from './asset/exportPDF.module.scss';
const ExportPDF = ({ isExporting = false }) => {
    return (
        <div className={styles.exportDashboard}>
            {isExporting ? (
                <div className={styles.spinner}>
                    <svg className={styles.exportDashboardChild} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="32" height="32" rx="8" fill="#FCFCFC" />
                        <circle cx="16" cy="16" r="6" stroke="#220EC9" strokeWidth="2" strokeLinecap="round" strokeDasharray="9.42 9.42">
                            <animateTransform attributeName="transform" type="rotate" from="0 16 16" to="360 16 16" dur="1s" repeatCount="indefinite" />
                        </circle>
                    </svg>
                </div>
            ) : (
                <svg className={styles.exportDashboardChild} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="32" height="32" rx="8" fill="#FCFCFC" />
                    <path d="M16 10V20M16 20L12 16M16 20L20 16" stroke="#220EC9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M10 22H22" stroke="#220EC9" strokeWidth="2" strokeLinecap="round" />
                </svg>
            )}
            <div className={styles.exportReportParent}>
                <div className={styles.exportReport}>
                    {isExporting ? 'Exporting...' : 'Export report'}
                </div>
                <div className={styles.pdfFile}>Pdf file</div>
            </div>
        </div>
    );
};

export default ExportPDF;
